// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Row (Property 1 = Default) ───────────────────────────────────────────── */

.scl--cms-components-recentReplaceMedia-row {
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 12px 0px;
  gap: 16px;
  width: 100%;
  height: 58px;
  border-bottom: 1px solid rgba(229, 229, 231, 0.2);
  position: relative;
  background: transparent;
}

/* ── Avatar ───────────────────────────────────────────────────────────────── */

.scl--cms-components-recentReplaceMedia-avatar {
  width: 50px;
  height: 50px;
  border-radius: 4px;
  overflow: hidden;
  flex-shrink: 0;
  order: 1;
  flex-grow: 0;
}

.scl--cms-components-recentReplaceMedia-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

/* ── Text block ──────────────────────────────────────────────────────────── */

.scl--cms-components-recentReplaceMedia-text {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding: 0px;
  gap: 5px;
  width: 214px;
  height: 42px;
  flex: none;
  order: 2;
  flex-grow: 1;          /* ← was flex-grow: 0, now grows to fill space */
  overflow: hidden;
  /* transition removed */
}


/* Hover state: text shrinks to make room for delete button (width 282px per Figma) */
.scl--cms-components-recentReplaceMedia-row.hovered
.scl--cms-components-recentReplaceMedia-text {
  width: 282px;
}

/* File name */
.scl--cms-components-recentReplaceMedia-name {
  font-family: 'Inter', sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 22px;
  color: #323539;
  flex: none;
  order: 0;
  flex-grow: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
}

/* File size */
.scl--cms-components-recentReplaceMedia-size {
  font-family: 'Inter', sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  color: #8A8B8F;
  flex: none;
  order: 1;
  flex-grow: 0;
}

/* ── Delete button ────────────────────────────────────────────────────────── */
.scl--cms-components-recentReplaceMedia-deleteBtn {
  width: 20px;
  height: 20px;
  background: transparent;
  border: none;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 0;
  flex-shrink: 0;
  margin-left: auto;     /* ← pushes button to far right */
  order: 3;

  opacity: 0;
  pointer-events: none;
  transition: opacity 0.3s ease;
  /* transition removed */
}
.scl--cms-components-recentReplaceMedia-row.hovered
.scl--cms-components-recentReplaceMedia-deleteBtn {
  opacity: 1;
  pointer-events: all;
}

.scl--cms-components-recentReplaceMedia-deleteBtn:hover  {
  background: var(--secondarycolors-red100);
}

.scl--cms-components-recentReplaceMedia-deleteBtn:active {
  background: var(--secondarycolors-red100);
}
.scl--cms-components-recentReplaceMedia-deleteBtn:active svg{
  stroke: var(--primarypalette-red);
}`, "",{"version":3,"sources":["webpack://./src/component-controller-mod/component-serv/dashboard-fs-cp/recent-activity-dsb-op/recent-replace-media/css/recentReplaceMedia.css"],"names":[],"mappings":"AAAA,gFAAgF;;AAEhF;EACE,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,iDAAiD;EACjD,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA,gFAAgF;;AAEhF;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA,+EAA+E;;AAE/E;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,YAAY;EACZ,QAAQ;EACR,YAAY;EACZ,YAAY;EACZ,UAAU;EACV,QAAQ;EACR,YAAY,WAAW,gDAAgD;EACvE,gBAAgB;EAChB,uBAAuB;AACzB;;;AAGA,qFAAqF;AACrF;;EAEE,YAAY;AACd;;AAEA,cAAc;AACd;EACE,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,UAAU;EACV,QAAQ;EACR,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,WAAW;AACb;;AAEA,cAAc;AACd;EACE,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,UAAU;EACV,QAAQ;EACR,YAAY;AACd;;AAEA,gFAAgF;AAChF;EACE,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,UAAU;EACV,cAAc;EACd,iBAAiB,MAAM,iCAAiC;EACxD,QAAQ;;EAER,UAAU;EACV,oBAAoB;EACpB,6BAA6B;EAC7B,uBAAuB;AACzB;AACA;;EAEE,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,yCAAyC;AAC3C;AACA;EACE,iCAAiC;AACnC","sourcesContent":["/* ── Row (Property 1 = Default) ───────────────────────────────────────────── */\n\n.scl--cms-components-recentReplaceMedia-row {\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  padding: 12px 0px;\n  gap: 16px;\n  width: 100%;\n  height: 58px;\n  border-bottom: 1px solid rgba(229, 229, 231, 0.2);\n  position: relative;\n  background: transparent;\n}\n\n/* ── Avatar ───────────────────────────────────────────────────────────────── */\n\n.scl--cms-components-recentReplaceMedia-avatar {\n  width: 50px;\n  height: 50px;\n  border-radius: 4px;\n  overflow: hidden;\n  flex-shrink: 0;\n  order: 1;\n  flex-grow: 0;\n}\n\n.scl--cms-components-recentReplaceMedia-img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n}\n\n/* ── Text block ──────────────────────────────────────────────────────────── */\n\n.scl--cms-components-recentReplaceMedia-text {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-start;\n  padding: 0px;\n  gap: 5px;\n  width: 214px;\n  height: 42px;\n  flex: none;\n  order: 2;\n  flex-grow: 1;          /* ← was flex-grow: 0, now grows to fill space */\n  overflow: hidden;\n  /* transition removed */\n}\n\n\n/* Hover state: text shrinks to make room for delete button (width 282px per Figma) */\n.scl--cms-components-recentReplaceMedia-row.hovered\n.scl--cms-components-recentReplaceMedia-text {\n  width: 282px;\n}\n\n/* File name */\n.scl--cms-components-recentReplaceMedia-name {\n  font-family: 'Inter', sans-serif;\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 22px;\n  color: #323539;\n  flex: none;\n  order: 0;\n  flex-grow: 0;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  width: 100%;\n}\n\n/* File size */\n.scl--cms-components-recentReplaceMedia-size {\n  font-family: 'Inter', sans-serif;\n  font-style: normal;\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 16px;\n  color: #8A8B8F;\n  flex: none;\n  order: 1;\n  flex-grow: 0;\n}\n\n/* ── Delete button ────────────────────────────────────────────────────────── */\n.scl--cms-components-recentReplaceMedia-deleteBtn {\n  width: 20px;\n  height: 20px;\n  background: transparent;\n  border: none;\n  border-radius: 4px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  padding: 0;\n  flex-shrink: 0;\n  margin-left: auto;     /* ← pushes button to far right */\n  order: 3;\n\n  opacity: 0;\n  pointer-events: none;\n  transition: opacity 0.3s ease;\n  /* transition removed */\n}\n.scl--cms-components-recentReplaceMedia-row.hovered\n.scl--cms-components-recentReplaceMedia-deleteBtn {\n  opacity: 1;\n  pointer-events: all;\n}\n\n.scl--cms-components-recentReplaceMedia-deleteBtn:hover  {\n  background: var(--secondarycolors-red100);\n}\n\n.scl--cms-components-recentReplaceMedia-deleteBtn:active {\n  background: var(--secondarycolors-red100);\n}\n.scl--cms-components-recentReplaceMedia-deleteBtn:active svg{\n  stroke: var(--primarypalette-red);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
